import type { Locale, WhatsAppIntentContract } from "@chams-pay/contracts";
import { deviceFetch } from "./client.js";

const WHATSAPP_INTENT_TIMEOUT_MS = 15_000;

export function whatsappMessageFromIntent(intentUrl: string): string {
  const parsed = new URL(intentUrl);
  if (parsed.origin !== "https://wa.me" || !/^\/\d+$/.test(parsed.pathname))
    throw new Error("whatsapp");
  const message = parsed.searchParams.get("text");
  if (!message) throw new Error("whatsapp");
  return message;
}

function validatedIntentUrl(intentUrl: string): string {
  whatsappMessageFromIntent(intentUrl);
  return intentUrl;
}

export async function prepareParentWhatsAppIntent({
  paymentId,
  locale,
  csrf,
}: {
  readonly paymentId: string;
  readonly locale: Locale;
  readonly csrf: string;
}): Promise<string> {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), WHATSAPP_INTENT_TIMEOUT_MS);
  try {
    const response = await deviceFetch(`/api/operations/receipts/${paymentId}/whatsapp-intent`, {
      method: "POST",
      headers: { "content-type": "application/json", "x-csrf-token": csrf },
      body: JSON.stringify({ locale }),
      signal: controller.signal,
    });
    if (!response.ok) throw new Error("whatsapp");
    const intent = (await response.json()) as WhatsAppIntentContract;
    return validatedIntentUrl(intent.intentUrl);
  } finally {
    window.clearTimeout(timeout);
  }
}
